module.exports = __webpack_public_path__ + "VIPV15.png?27c229cd83e00be9c41a54c56f44a666";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV15.png
// module id = 109
// module chunks = 0